import { createRouter, createWebHistory } from 'vue-router';
import ContactsBlock from "./ContactsBlock.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: []
});

bootVue('.vue-contacts-block', ContactsBlock, {
  jsonProps: ['continents', 'countries', 'defaultCountryValue', 'defaultCompanyTypeValue', 'defaultContinentValue', 'defaultLocationTypeValue', 'defaultOfferingValue', 'defaultIndustryValue', 'singleContact', 'selectedCountries'],
  beforeMount: (el, props) => {},
  createAppWrapper: (wrapped, props) => {
    const app = createApp(wrapped, props);
    app.use(router);
    return app;
  }
});